import styled from 'styled-components';

export default {
  Modal: styled.div`
    box-sizing: border-box;
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 0;
    background-color: rgba(0, 0, 0, 0.5);
    border: 1px solid grey;
    ${({ $isActive }) => ($isActive ? 'display: block' : 'display: none')}
  `
};